module.exports = __webpack_public_path__ + "img/66_12.5fc1cd41.png";